export const initialState = {
	modal: {
		id: "",
		isModalOpen: false,
		config: {},
	},
	canCustomerDisablePopup: false,
	singleFlexInsurance: false,
	containsFlexInsurance: false,
	products: {
		isVisible: false,
		mainProduct: {
			productName: "",
			url: "",
			imgUrl: "",
			imgUrl400: "",
			productId: "",
			groupId: "",
			description: "",
			quantity: 0,
			insurance: [],
			insuranceProductId: "",
			isFlexInsurance: false,
			selectedInsuranceId: null,
			price: 0,
			cartId: "",
			cartItemId: "",
			subscription: {
				subscriptionTitle: "",
				subscriptionSubtitle: "",
				subscriptionSubtitleReadMore: "",
				moreInfoTableFirst: "",
				moreInfoTableSecond: "",
				moreInfoTableThird: "",
				monthlyPriceLabel: "",
				totalPriceLabel: "",
				exampleCalculationLabel: "",
				exampleCalculationText: "",
				switchBy: "",
				highlightPayToday: "",
				highlightFreeReturn: "",
				highlightReplaceAfter: "",
				highlightNewOwner: "",
				highlightThisIsFlex: "",
				doYouWantToKeepProducts: "",
				moreInfoBottom: "",
				readMoreBottom: "",
				monthlyPrice: "",
				isBoughtWithSubscription: false,
				taxRate: 0,
				months: "",
				renewalPeriod: 0,
				productPrice: 0,
				youSave: 0,
				payToday: "",
				subscriptionTerms: {
					termOfCreditAgreement: "",
					komplettPrice: 0,
				},
			},
			configServices: [],
		},
		chosenProducts: [],
		recommendedProducts: {
			isFetching: false,
			products: [],
		},
	},
	currencyCode: "NOK",
	recommendedProductsHeader: "",
	storeContext: {
		isNet: false,
		language: "no",
	},
	error: {
		isError: false,
		level: "info" as const,
		errorMessage: "",
	},
	configuration: {
		isPopupEnabled: true,
	},
	showSubscriptionDataOnly: false,
	selectedConfigServices: [],
	attachedConfigServices: [],
	configServiceGroups: [],
	isFetching: false,
	isAddToCartDrawer: false,
	isGamePassAvailable: false,
};
